import { returnSelf } from '../../run-callback.js';
export const scriptHook = {
    resolve: (returnSelf), // prettier-ignore
};
export const linkHook = {
    resolve: (returnSelf), // prettier-ignore
};
export function injectScript(path, async = true, doc = document, crossOrigin = 'anonymous', isModule = false) {
    if (path) {
        const script = doc.createElement('script');
        script.async = async;
        if (crossOrigin) {
            script.crossOrigin = crossOrigin;
        }
        if (isModule) {
            script.type = 'module';
        }
        script.src = path;
        return doc.head.appendChild(scriptHook.resolve(script));
    }
}
export function preloadScript(script) {
    const preloadLink = document.createElement('link');
    preloadLink.href = script;
    preloadLink.rel = 'preload';
    preloadLink.as = 'script';
    document.head.appendChild(linkHook.resolve(preloadLink));
}
export function injectScriptInline(data, doc = document) {
    if (data) {
        const script = doc.createElement('script');
        script.innerHTML = data;
        return doc.body.appendChild(script);
    }
}
//# sourceMappingURL=script.js.map